<template>
  <div class="box-block pt-0 px-0">
    <div class="board-view mt-0">
      <div class="row no-gutters row-eq-height">
        <div
            v-for="phase in groupedPhases"
            :key="'phase-' + phase.id"
            class="workflow-phase"
            :class="{'workflow-phase--collapsed': !isPhaseExpanded(phase.id)}"
        >
          <div
              v-if="!isPhaseExpanded(phase.id)"
              class="workflow-phase-collapsed"
              @click="expandPhase(phase.id)"
          >
            <i class="bx bx-folder-open"></i>
            <div class="workflow-phase-collapsed-title">{{ phase.name }}</div>
            <div class="workflow-phase-count">{{ getPhaseCount(phase.statuses) }}</div>
          </div>
          <div v-else class="workflow-phase-expanded">
            <div class="workflow-phase-header">
              <div class="workflow-phase-title" @click="collapsePhase(phase.id)">
                <i class="bx bx-folder-open"></i>
                {{ phase.name }}
              </div>
              <button type="button" class="workflow-phase-collapse" @click="collapsePhase(phase.id)">
                <i class="bx bx-collapse-alt"></i>
                Collapse
              </button>
            </div>
            <div class="workflow-phase-columns">
              <board-column
                  v-for="ce_status in phase.statuses"
                  :ref="'column-' + ce_status.ce_status_id"
                  :key="'all'+ce_status.ce_status_id"
                  :count="getCards[ce_status.ce_status_id] ? getCards[ce_status.ce_status_id].length : 0"
                  :cards="getCardsLimited(ce_status.ce_status_id)"
                  :ce_status="ce_status"
                  :categories="categories"
                  :isShowMore="isShowMore(ce_status.ce_status_id)"
                  @isDraggedAll="v => $emit('isDraggedAll', v)"
                  @increaseLimit="increaseLimit(ce_status.ce_status_id)"
                  @deleteCard="v => $emit('deleteCard', v)"
                  @openDeclineORMJobModal="id => $emit('openDeclineORMJobModal', id)"
                  @acceptORMJob="id => $emit('acceptORMJob', id)"
                  @setCardPriority="(cardId, priority )=> $emit('setCardPriority', cardId, priority)"
                  @addToVehicleInBoard="(cardId, number )=> $emit('addToVehicleInBoard', cardId, number)"
                  @addToDepartureBoard="(cardId, number )=> $emit('addToDepartureBoard', cardId, number)"
                  @assignedToPerson="(data, user )=> $emit('assignedToPerson', data, user)"
                  @onRightClickByMenu="(index, value)=> $emit('onRightClickByMenu', index, value)"
                  @markAsRead="(id)=> $emit('markAsRead', id)"
                  @openMenuForBoardCards="(event, title, cardId, cardNumber) => {$emit('openMenuForBoardCards', event, title, cardId, cardNumber)}"
                  @changedFilter="v => changedFilter(v, ce_status.ce_status_id)"
                  :index="ce_status.__boardIndex"
              ></board-column>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoardColumn from './cards-board-column'
import _ from "lodash";
import {mapGetters} from "vuex";

export default {
  name: "cards-board",
  components: {
    BoardColumn
  },
  props: {
    cards: {
      type: Array,
      default() {
        return []
      }
    },
    categories: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      limit: {},
      limitCount: 50,
      filter: {},
      cards2: this.cards ? this.cards.slice() : [],
      countOfRequests: 0,
      activePhaseIds: [],
      isPhaseStateInitialized: false,
    }
  },
  computed: {
    ...mapGetters({
      cardFilter: 'cardFilter',
      hiddenStatuses: 'card/hiddenStatuses',
      ceStatuses: 'ceStatuses',
      vendorId: 'vendorId',
    }),
    phaseStorageKey() {
      return `cards.board.phases.activePhaseIds.${this.vendorId || 'default'}`;
    },

    getCards () {
      let obj = {}
      _.forEach(this.ceStatuses, (c) => {
        let id = c.ce_status_id
        let cards = _.filter(_.uniqBy(this.cards2, 'card_id'), (c) => {
          let filter = this.filter[id] ? this.filter[id] : ''
          return Number(id) == Number(c.card_status) && this.isCheckedByFilter(c, filter)
        })
        cards = _.uniqBy(cards, 'card_id')

        obj[id] = cards
      })

      return obj
    },
    visibleStatuses() {
      return _.filter(this.ceStatuses, (status) => {
        return !this.hiddenStatuses.userHiddenStatuses.includes(status.ce_status_id)
            && !this.hiddenStatuses.vendorHiddenStatuses.includes(status.ce_status_id)
      })
    },
    groupedPhases() {
      let phases = []
      _.forEach(this.visibleStatuses, (status, index) => {
        let phaseId = status.phaseId || status.phase_id || 'unassigned'
        let phaseName = status.phaseName || status.phase_name || 'Workflow'
        let phase = _.find(phases, (item) => item.id === phaseId)
        if (!phase) {
          phase = {
            id: phaseId,
            name: phaseName,
            order: status.phaseOrder || status.phase_order || phases.length,
            statuses: []
          }
          phases.push(phase)
        }
        phase.statuses.push({
          ...status,
          __boardIndex: index
        })
      })
      return _.orderBy(phases, ['order'], ['asc'])
    },
  },
  created() {
    this.isCreated = true
    this.debouncedSetCards = _.debounce((v) => {
      this.setCards(v)
    }, 500);
    // Load saved phase state from localStorage only if it's not empty
    const savedPhaseIds = this.$storage.get(this.phaseStorageKey)
    if (savedPhaseIds && _.isArray(savedPhaseIds) && !_.isEmpty(savedPhaseIds)) {
      this.activePhaseIds = savedPhaseIds
      this.isPhaseStateInitialized = true
    } else {
      // If no saved state, expand all phases by default
      this.expandAllPhases();
    }
  },
  watch: {
    cardFilter: {
      handler(v) {
        this.setCards(this.cards)
      },
      immediate: true,
      deep: true
    },
    cards: {
      handler (newVal) {
        let v = newVal ? newVal.slice() : []
        this.countOfRequests++
        if (!this.isCreated) {
          this.setCards(v)
        } else {
          this.debouncedSetCards(v)
          if (this.countOfRequests == 10 || this.countOfRequests == 5) {
            this.setCards(v)
          }
        }
      },
      immediate: true
    },
    groupedPhases: {
      handler(v) {
        if (!this.isPhaseStateInitialized && !_.isEmpty(v)) {
          this.activePhaseIds = _.map(v, p => String(p.id))
          this.isPhaseStateInitialized = true
        }
      },
      immediate: true
    },
    activePhaseIds: {
      handler(newVal) {
        if (this.isPhaseStateInitialized) {
          this.$storage.set(this.phaseStorageKey, newVal)
        }
      },
      deep: true
    }
  },
  methods: {
    getIds(id) {
      return this.$refs?.['column-' + id]?.[0]?.getIds2()
    },
    isPhaseExpanded(id) {
      return this.activePhaseIds.some(activeId => String(activeId) === String(id))
    },
    expandPhase(id) {
      if (!this.isPhaseExpanded(id)) {
        this.activePhaseIds.push(String(id))
      }
    },
    collapsePhase(id) {
      this.activePhaseIds = _.filter(this.activePhaseIds, (phaseId) => String(phaseId) !== String(id))
    },
    expandAllPhases() {
      this.activePhaseIds = _.map(this.groupedPhases, p => String(p.id))
    },
    collapseAllPhases() {
      this.activePhaseIds = []
    },
    getPhaseCount(statuses) {
      return _.sumBy(statuses, (status) => {
        return this.getCards[status.ce_status_id] ? this.getCards[status.ce_status_id].length : 0
      })
    },
    setCards(v) {
      if (_.isEqual(v, this.cards2)) {
        return
      }
      this.cards2.splice(0, this.cards2.length)
      this.$nextTick(() => {
        this.cards2.splice(0, this.cards2.length)
        let value = _.orderBy(_.uniqBy(v, 'card_id'), [(itm) => Number(itm.boardSort), 'created_on'],['asc'])
        this.cards2.push(...value)
      })
    },
    changedFilter(v, id) {
      let filterCopy = _.cloneDeep(this.filter)
      filterCopy[id] = v
      this.$set(this, 'filter', filterCopy)
    },
    isCheckedByFilter(c, f) {
      let filter = _.trim(_.toLower(f))
      if (_.isEmpty(filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.card_number)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.rego_number)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.make)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.model)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.priority)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.insurance)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.colour)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.customer_name)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.card_id)), filter)) {
        return true
      }
      if (_.includes(_.trim(_.toLower(c.partNumbers)), filter)) {
        return true
      }
      // if (_.includes(_.trim(_.toLower(c.filters)), filter)) {
      //   return true
      // }
      if (_.includes(_.trim(_.toLower(c.claim_number)), filter)) {
        return true
      }
      return false
    },
    getCardsLimited(id) {
      let limit = this.limit[id] ? this.limit[id] : this.limitCount
      return _.slice(this.getCards?.[id], 0, limit)
    },
    increaseLimit(id) {
      let limitCopy = _.cloneDeep(this.limit)
      if (limitCopy[id]) {
        limitCopy[id] += this.limitCount
      } else {
        limitCopy[id] = this.limitCount * 2
      }
      this.$set(this, 'limit', limitCopy)
    },
    isShowMore(id) {
      let limit = this.limit[id] ? this.limit[id] : this.limitCount
      return this.getCards?.[id]?.length > limit
    },
  }
}
</script>

<style scoped>
.board-view {
  overflow-x: auto;
}

.board-view {
  scrollbar-width: thin;
  scrollbar-color: #B7B8C0; /* #5e79ff; */
}

.board-view::-webkit-scrollbar-thumb {
  background-color: #B7B8C0; /* #5e79ff; */
}

.board-view::-webkit-scrollbar {
  /* width: 7px; */
  height: 7px;
}

* {
  box-sizing: border-box;
}

.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: calc(100vh - 255px);
  transition: all 0.5s;
  flex-wrap: nowrap;
  align-items: stretch;
}
.row.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.row.no-gutters > [class^="col-"],
.row.no-gutters > [class*=" col-"] {
  padding-right: 0;
  padding-left: 0;
}
.V3 .cards-page .no-gutters {
  display: flex;
  justify-content: flex-start !important;
}

.workflow-phase {
  flex-shrink: 0;
  flex-grow: 0;
  height: 100%;
  margin-right: 12px;
}

.workflow-phase--collapsed {
  width: 48px !important;
  min-width: 48px !important;
  max-width: 48px !important;
  flex: 0 0 48px !important;
}

.workflow-phase-collapsed {
  width: 48px !important;
  min-width: 48px !important;
  max-width: 48px !important;
  flex: 0 0 48px !important;
  height: 100%;
  background: #f8f9fb;
  border: 1px solid #e1e2e5;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 0;
  color: rgba(28, 31, 57, 0.65);
  flex-shrink: 0;
}

.workflow-phase-collapsed:hover {
  background: #f3f5f8;
}

.workflow-phase-collapsed i {
  color: rgba(28, 31, 57, 0.45);
  font-size: 18px;
  margin-bottom: 14px;
}

.workflow-phase-collapsed-title {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg);
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
}

.workflow-phase-count {
  margin-top: auto;
  min-width: 24px;
  padding: 2px 6px;
  border-radius: 10px;
  color: #5E79FF;
  background: rgba(94, 121, 255, 0.12);
  text-align: center;
  font-weight: bold;
}

.workflow-phase-expanded {
  height: 100%;
  background: #fff;
  border: 1px solid #e1e2e5;
  border-radius: 6px;
  box-shadow: 0 2px 7px rgba(28, 31, 57, 0.06);
  padding: 8px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.workflow-phase-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef0f4;
  padding: 0 2px 8px;
  margin-bottom: 8px;
}

.workflow-phase-title {
  color: #1C1F39;
  font-weight: bold;
  cursor: pointer;
}

.workflow-phase-title i {
  color: rgba(28, 31, 57, 0.45);
  margin-right: 6px;
}

.workflow-phase-collapse {
  border: 1px solid #e1e2e5;
  border-radius: 4px;
  background: #f8f9fb;
  color: rgba(28, 31, 57, 0.6);
  cursor: pointer;
  padding: 3px 7px;
}

.workflow-phase-columns {
  display: flex;
  flex: 1;
  overflow: hidden;
}

</style>

